import React from "react";
import { connect } from "react-redux";
import Radio from "Components/common/Radio/Radio";

@connect(store => {
    return {
        projectSettings: store.projectSettings
    };
})


class AdjustedDates extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, value } = this.props;

        const onChange = (value) => {
            dispatch({ type: "UPDATE_SETTINGS_ADJUSTED", value: value });
        }

        return (
            <div class="workingDaysContainer">
                <div class="sectionHeader">
                    <label>Adjusted Dates</label>
                </div>
                <div class="sectionBody">
                    <p>Please select the action to be performed if a due date falls on a holiday or non-working day.</p>
                    <div class="actionItem">
                        <Radio checked={value === "before"} onChange={() => onChange("before")} />
                        <span>Automatically set adjusted dates <strong>before</strong> holiday/s and non-working day/s (Recommended)</span>
                    </div>
                    <div class="actionItem">
                        <Radio checked={value === "after"} onChange={() => onChange("after")} />
                        <span>Automatically set adjusted dates <strong>after</strong> holiday/s and non-working day/s</span>
                    </div>
                    <div class="actionItem">
                        <Radio checked={value === "noChange"} onChange={() => onChange("noChange")} />
                        <span>Set adjusted dates to be the <strong>same</strong> as due dates</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default AdjustedDates;